import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import Loader from "@/components/Loader";

export default function OrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/orders/${id}`).then(({ data }) => setOrder(data)).catch((e) => setError(e?.response?.data?.detail || "Introuvable"));
  }, [id]);

  if (error) return <div className="max-w-2xl mx-auto p-8 text-center text-red-400">{error} — <Link to="/account" className="underline">retour</Link></div>;
  if (!order) return <Loader />;

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <Link to="/account" className="text-neutral-400 text-sm">← Retour au compte</Link>
      <div className="card-hsg p-6 mt-4">
        <div className="flex justify-between items-start gap-3">
          <div>
            <div className="font-mono text-xs text-neutral-500">Commande #{order.id.slice(0, 8).toUpperCase()}</div>
            <h1 className="text-2xl font-black mt-1">{order.kind === "ticket" ? "Billets festival" : order.kind === "bracelet" ? "Recharge bracelet" : order.kind}</h1>
            <div className="text-neutral-400 text-sm mt-1">{new Date(order.created_at).toLocaleString("fr-CH")}</div>
          </div>
          <span className="chip" style={{ background: "#A1C86122", color: "#A1C861", border: "1px solid #A1C86155" }}>{order.status}</span>
        </div>

        <div className="mt-6 space-y-2">
          {(order.items || []).map((it, i) => (
            <div key={i} className="flex justify-between text-sm">
              <span>{it.name || it.id} × {it.quantity || 1}</span>
              <span>CHF {(Number(it.price_chf || 0) * (it.quantity || 1)).toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="border-t border-neutral-800 mt-4 pt-3 flex justify-between font-bold text-lg">
          <span>Total</span><span>CHF {Number(order.total_chf || 0).toFixed(2)}</span>
        </div>

        {order.qr_payload && (
          <div className="mt-6 text-center">
            <div className="chip mb-2" style={{ background: "#5BC5F222", color: "#5BC5F2", border: "1px solid #5BC5F255" }}>🎟️ Billet</div>
            <div className="bg-white text-black text-3xl font-mono font-black tracking-widest px-6 py-4 rounded-xl inline-block">{order.qr_payload}</div>
            <p className="text-neutral-400 text-xs mt-2">Présentez ce code à l'entrée</p>
          </div>
        )}
      </div>
    </div>
  );
}
